import api from "../http/api";

export const regulatoryInstitution = async ({
  institutionId,
  startDate,
  endDate,
  knowledgeArea,
  discipline,
  courseTypeId,
  courseGradeId,
  localityId,
  filtermodality,
  filtershift
}) => {
  const queryParams = new URLSearchParams();

  if (startDate) {
    queryParams.append("startDate", startDate);
  }
  if (endDate) {
    queryParams.append("endDate", endDate);
  }
  if (knowledgeArea !== undefined && knowledgeArea !== null && knowledgeArea !== "") {
    queryParams.append("knowledgeArea", knowledgeArea);
  }
  if (discipline !== undefined && discipline !== null && discipline !== "") {
    queryParams.append("discipline", discipline);
  }
  if (courseTypeId !== undefined && courseTypeId !== null && courseTypeId !== "") {
    queryParams.append("courseType", courseTypeId);
  }
  if (courseGradeId !== undefined && courseGradeId !== null && courseGradeId !== "") {
    queryParams.append("courseGrade", courseGradeId);
  }
  if (localityId !== undefined && localityId !== null && localityId !== "") {
    queryParams.append("locality", localityId);
  }
  if (filtermodality !== undefined && filtermodality !== null && filtermodality !== "") {
    queryParams.append("modality", filtermodality);
  }
  if (filtershift !== undefined && filtershift !== null && filtershift !== "") {
    queryParams.append("shift", filtershift);
  }

  const qs = queryParams.toString();

  try {
    const response = await api.client.get(`api/v1/regulatoryInstitution${qs ? `?${qs}` : ""}`, {
      headers: {
        institutionId
      }
    });

    if (response.status === 204) {
      return { noContent: true };
    }

    return response.data;
  } catch (error) {
    throw new Error("Falha na conexão com a API de indicadores regulatórios");
  }
};

export const regulatoryTeachersByRegime = async ({
  institutionId,
  regime,
  qualification,
  startDate,
  endDate,
  knowledgeArea,
  discipline,
  courseTypeId,
  courseGradeId,
  localityId,
  filtermodality,
  filtershift
}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("regime", regime);
  if (qualification) queryParams.append("qualification", qualification);
  if (startDate) queryParams.append("startDate", startDate);
  if (endDate) queryParams.append("endDate", endDate);
  if (knowledgeArea) queryParams.append("knowledgeArea", knowledgeArea);
  if (discipline) queryParams.append("discipline", discipline);
  if (courseTypeId) queryParams.append("courseType", courseTypeId);
  if (courseGradeId) queryParams.append("courseGrade", courseGradeId);
  if (localityId) queryParams.append("locality", localityId);
  if (filtermodality) queryParams.append("modality", filtermodality);
  if (filtershift) queryParams.append("shift", filtershift);

  const response = await api.client.get(
    `api/v1/regulatoryInstitution/TeachersByRegime?${queryParams.toString()}`,
    { headers: { institutionId } }
  );

  return response.data;
};
